import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback) {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

const FB_HTML_TITLE = 'Rafid Seed — Agriculture & Organic Farms';
const FB_SOCIAL_TITLE = 'Rafid Seed — Rooted in Nature, Growing the Future';
const FB_DESCRIPTION =
  'Rafid Seed — Agriculture & organic farms. Rooted in Nature, Growing the Future. Sustainable practices from soil to harvest.';
const FB_KEYWORDS =
  'Rafid Seed, agriculture, organic farming, sustainable farming, crop management, farm development, soil restoration';
const FB_AUTHOR = 'Rafid Seed';
const FB_SITE_NAME = 'Rafid Seed';
const FB_SHARE_IMAGE =
  'https://agrezen.zozothemes.com/wp-content/uploads/2025/10/home-3-intro-4.webp';
const FB_SHARE_IMAGE_ALT = 'Rafid Seed — agriculture and organic farms hero imagery';
const FB_THEME_COLOR = '#14261c';
const FB_ROBOTS = 'index, follow';
const FB_OG_LOCALE = 'en_US';

/** Resolved SEO / social meta for `<head>` (bundled defaults + API). */
export function resolveSiteSeo(site) {
  const d = DEFAULT_SITE.seo && typeof DEFAULT_SITE.seo === 'object' ? DEFAULT_SITE.seo : {};
  const x = site?.seo && typeof site.seo === 'object' ? site.seo : {};

  const htmlTitle = strPrefer(x.htmlTitle, d.htmlTitle, FB_HTML_TITLE);
  const socialTitle = strPrefer(x.socialTitle, d.socialTitle, FB_SOCIAL_TITLE);

  const description = strPrefer(x.description, d.description, FB_DESCRIPTION);
  const socialDescription = strPrefer(x.socialDescription, d.socialDescription, description);

  return {
    htmlTitle,
    socialTitle,
    description,
    socialDescription,
    keywords: strPrefer(x.keywords, d.keywords, FB_KEYWORDS),
    author: strPrefer(x.author, d.author, FB_AUTHOR),
    siteName: strPrefer(x.siteName, d.siteName, FB_SITE_NAME),
    shareImageUrl: strPrefer(x.shareImageUrl, d.shareImageUrl, FB_SHARE_IMAGE),
    shareImageAlt: strPrefer(x.shareImageAlt, d.shareImageAlt, FB_SHARE_IMAGE_ALT),
    canonicalUrl: typeof x.canonicalUrl === 'string' ? x.canonicalUrl.trim() : typeof d.canonicalUrl === 'string' ? d.canonicalUrl.trim() : '',
    themeColor: strPrefer(x.themeColor, d.themeColor, FB_THEME_COLOR),
    robots: strPrefer(x.robots, d.robots, FB_ROBOTS),
    ogLocale: strPrefer(x.ogLocale, d.ogLocale, FB_OG_LOCALE),
  };
}
